import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "fileInput"]

  connect() {
    window.filesMap = window.filesMap || new Map()
  }

  handleFileUpload(event) {
    const files = event.target.files
    if (!files || files.length === 0) {
      console.error("No files provided in event")
      return
    }

    window.filesMap.clear()
    Array.from(files).forEach(file => {
      let path = file.webkitRelativePath || file.name
      path = path.replace(/"/g, "'")
      console.log(`Adding file to filesMap: ${path}`)
      window.filesMap.set(path, { file, path })
    })
    console.log("Updated filesMap:", Array.from(window.filesMap.keys()))
  }

  handleSubmit(event) {
    event.preventDefault()
    console.log("Submit handler triggered")

    const form = event.currentTarget
    const formData = new FormData(form)
    const filename = form.querySelector('input[name="filename"]').value

    console.log(`Looking for file: ${filename}`)

    if (!window.filesMap || window.filesMap.size === 0) {
      console.error("No files found in global filesMap")
      return
    }

    const matchingPath = Array.from(window.filesMap.keys()).find(path =>
      path.includes(filename)
    )

    if (matchingPath) {
      const { file, path } = window.filesMap.get(matchingPath)
      console.log(`File found: ${file.name}, adding to formData with path: ${path}`)
      formData.append('file', file)
      formData.append('folder_path', path)
    } else {
      console.error(`File not found in filesMap for: ${filename}`)
      return
    }

    fetch(form.action, {
      method: form.method,
      body: formData,
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      },
      credentials: 'same-origin'
    })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const streamElement = doc.querySelector("turbo-stream")
        if (streamElement) {
          Turbo.renderStreamMessage(html)
        }
      })
      .catch(error => {
        console.error("Save failed:", error)
      })
  }

  async submitAllForms(event) {
    event.preventDefault()
    console.log("Submitting all forms")

    // Get the button that was clicked and disable it
    const button = event.currentTarget
    button.disabled = true
    button.innerHTML = 'Αποθήκευση σε εξέλιξη...' // "Saving in progress..." in Greek

    try {
      // Select all forms within the accordion
      const forms = this.element.querySelectorAll("form.document-form")

      // Use Promise.all to handle all form submissions
      await Promise.all(
        Array.from(forms).map(form => {
          return new Promise((resolve, reject) => {
            form.requestSubmit()
            resolve() // Resolve immediately since requestSubmit() is handled by handleSubmit
          })
        })
      )

      // All forms have been processed successfully
      button.innerHTML = 'Αποθήκευση σε εξέλιξη...' // "Successfully saved!" in Greek
      setTimeout(() => {
        button.disabled = false
        button.innerHTML = 'Αποθήκευση όλων των αρχείων' // Reset to original text
      }, 3000)
    } catch (error) {
      console.error("Error submitting forms:", error)
      button.disabled = false
      button.innerHTML = 'Σφάλμα - Δοκιμάστε ξανά' // "Error - Try again" in Greek
      setTimeout(() => {
        button.innerHTML = 'Αποθήκευση όλων των αρχείων' // Reset to original text
      }, 3000)
    }
  }
}